import * as React from 'react';
import ConnectedThemeProvider from '@configuratorware/configurator-frontendgui/App/Screens/Configurator/ThemeProvider';
import merge from 'lodash/merge';

const customTheme = {
  typography: {
    fontFamily: 'Jones-Medium',
    fontWeightMedium: '600',
  },
  shape: {
    borderRadius: 2,
  },
};

const overrideTheme = (theme) => {
  merge(theme.overrides, {
    MainButton: {
      root: {
        borderRadius: 2,
        border: '1px solid black',
        backgroundColor: 'white',
        '& span': {
          color: 'black',
          textTransform: 'uppercase',
        },
        '&:hover': {
          boxShadow: 'none',
          backgroundColor: 'black',
          '& span': {
            color: 'white',
          },
        },
      },
    },
    AddVisualElement: {
      card: {
        maxWidth: '100%',
      },
      addVisualButton: {
        width: 'calc(100% - 10px) !important',
        borderRadius: 2,
        border: '1px solid black',
        backgroundColor: 'white',
        fontSize: '0.7rem !important',
        [theme.breakpoints.down('xs')]: {
          width: '250px !important',
        },
        [theme.breakpoints.between('sm', 'xs')]: {
          width: 'auto !important',
        },
        '& b': {
          color: 'black',
          textTransform: 'uppercase',
        },
        '&:hover': {
          boxShadow: 'none',
          backgroundColor: 'black',
          '& b': {
            color: 'white',
          },
          '& span': {
            color: 'white',
          },
        },
        '& .material-icons': {
          marginRight: '0 !important',
          paddingLeft: '0 !important',
        },
        MuiIcon: {
          root: {
            marginRight: '0 !important',
            paddingLeft: '0 !important',
          },
        },
        '& svg': {
          marginRight: 5,
        },
      },
      addVisualContent: {
        padding: 12,
      },
      labelText: {
        minWidth: 'unset',
      },
    },
    Header: {
      headerRoot: {
        backgroundColor: 'white',
        boxShadow: 'none',
        borderBottom: '1px solid black',
      },
    },
    MuiButton: {
      contained: {
        boxShadow: 'none',
        '&.Mui-disabled': {
          backgroundColor: 'rgb(0 0 0 / 40%) !important',
        },
      },
    },
    Thumbnail: {
      inactiveDotMode: {
        color: 'black !important',
        backgroundColor: 'white',
        border: '2px solid black',
      },
      activeDotMode: {
        backgroundColor: 'black',
        color: 'white',
        border: '2px solid black',
      },
      dotContainer: {
        [theme.breakpoints.down('xs')]: {
          paddingRight: 5,
        },
        '&> div': {
          padding: 3,
          margin: 3,
          [theme.breakpoints.down('xs')]: {
            paddingBottom: 2,
          },
        },
        wrap: {
          coCallntainer: {
            margin: 8,
          },
        },
      },
    },
    AmountPrice: {
      card: {
        border: 'none !important',
        boxShadow: 'none',
        backgroundColor: 'transparent !important',
      },
      mainButton: {
        borderRadius: '2 !important',
        backgroundColor: 'black',
        border: 'none',
        '& span': {
          color: 'white',
          textTransform: 'uppercase',
        },
        '&:hover': {
          border: '1px solid black',
          backgroundColor: 'white',
          boxShadow: 'none',
          '& span': {
            color: 'black',
          },
        },
      },
    },
    DesignAreaControlbox: {
      colorAmountMessage: {
        display: 'none',
      },
      iconRootCheck: {
        color: '#B8E582',
      },
      GridContainer: {
        [theme.breakpoints.down('xs')]: {
          flexDirection: 'column',
          boxSizing: 'content-box',
        },
      },
      GridItemXS: {
        maxWidth: '100%',
      },
    },
    CallToAction: {
      hintText: {
        fontSize: '1rem',
      },
    },
    MuiCard: {
      root: {
        boxShadow: 'none',
        borderTop: 'none !important',
      },
    },
    MuiDialog: {
      paperFullWidth: {
        borderTop: 'none !important',
      },
    },
    ImageEditDialog: {
      alignGrid: {
        width: 385,
      },
      imagePreview: {
        maxHeight: 150,
      },
      dialogContent: {
        marginBottom: '0 !important',
      },
      imageUploadDropZone: {
        height: 290,
        [theme.breakpoints.down('xs')]: {
          height: '100%',
          minHeight: 300,
        },
      },
      previewImageWrapper: {
        marginBottom: '0 !important',
      },
      colorPreviewToggleContainer: {
        marginBottom: '0 !important',
      },
      imageUploadOwnershipCheckbox: {
        color: 'black !important',
      },
      PreviewDialogButton: {
        borderRadius: '2px !important',
        backgroundColor: 'black',
        border: 'none',
        '& span': {
          color: 'white',
          textTransform: 'uppercase',
        },
        '&:hover': {
          border: '1px solid black',
          backgroundColor: 'white',
          boxShadow: 'none',
          '& span': {
            color: 'black',
          },
        },
        '&:disabled span': {
          color: 'white !important',
        },
      },
      imageUploadButton: {
        border: '1px solid black',
        backgroundColor: '#000000',
        '& span': {
          color: 'white',
          textTransform: 'uppercase',
        },
        '&:hover': {
          border: '1px solid black',
          backgroundColor: 'white',
          boxShadow: 'none',
          '& span': {
            color: 'black',
          },
        },
        minWidth: 180,
        justifyContent: 'space-evenly',
        [theme.breakpoints.down('xs')]: {
          '& svg': {
            paddingRight: 5,
          },
        },
      },
      imageSelectButton: {
        borderRadius: 2,
        border: '1px solid black',
        backgroundColor: 'white',
        fontSize: '0.7rem',
        '& span': {
          color: 'black',
          textTransform: 'uppercase',
        },
        '&:hover': {
          boxShadow: 'none',
          backgroundColor: 'black',
          '& span': {
            color: 'white',
          },
          '& svg': {
            color: 'white',
          },
        },
        '& .material-icons': {
          marginRight: '0 !important',
          paddingLeft: '0 !important',
        },
        MuiIcon: {
          root: {
            marginRight: '0 !important',
            paddingLeft: '0 !important',
          },
        },
      },
      colorizeCaption: {
        '& svg': {
          margin: '0 8px',
        },
      },
    },
    AddImagePanel: {
      applyButton: {
        borderRadius: '2 !important',
        backgroundColor: '#808080',
        border: 'none',
        '& span': {
          color: 'white',
          textTransform: 'uppercase',
        },
        '&:hover': {
          border: '1px solid black',
          backgroundColor: 'white',
          boxShadow: 'none',
          '& span': {
            color: 'black',
          },
        },
      },
    },
    MuiTab: {
      textColorPrimary: {
        '&.Mui-selected': {
          color: 'black',
          textDecoration: 'underline',
        },
      },
    },
    PrivateTabIndicator: {
      colorPrimary: {
        display: 'none',
      },
    },
    CloseGraphicsEditorButton: {
      button: {
        margin: '0 14px !important',
        width: 'auto !important',
        padding: '7px 21px !important',
        [theme.breakpoints.down('xs')]: {
          margin: '0 10px !important',
          width: '250px !important',
        },
        backgroundColor: 'black',
        border: 'none',
        '& span': {
          color: 'white',
          textTransform: 'uppercase',
        },
        '&:hover': {
          border: '1px solid black',
          backgroundColor: 'white',
          boxShadow: 'none',
          '& span': {
            color: 'black',
          },
        },
        '& .MuiButton-label': {
          minWidth: 200,
          width: 200,
        },
      },
    },
    EditDesignButton: {
      button: {
        margin: '0 22px !important',
        width: 'auto !important',
      },
    },
    CustomSelect: {
      selectUnderline: {
        '&:after': {
          borderBottom: 'none',
        },
      },
    },
    DefaultLayout: {
      visualization: {
        [theme.breakpoints.up(1087)]: {
          width: 'calc(100% - 350px)',
          right: 350,
        },
      },
      toBottom: {
        [theme.breakpoints.down('xs')]: {
          display: 'flex',
          justifyContent: 'center',
        },
      },
    },
    MuiSwitch: {
      root: {
        alignItems: 'center',
      },
      switchBase: {
        top: 2,
        left: 4,
        '&$checked': {
          transform: 'translateX(16px)',
        },
      },
      thumb: {
        boxShadow: 'none',
        width: '100%',
        height: '100%',
        color: 'black !important',
        display: 'flex',
        padding: 5,
        marginTop: 3,
        marginLeft: 3,
      },
      track: {
        border: 'black 2px solid',
        borderRadius: '15px',
        opacity: '1 !important',
        backgroundColor: 'white  !important',
      },
      checked: {},
    },
    MessageBox: {
      icon: {
        display: 'none',
      },
      root: {
        justifyContent: 'center',
      },
      successRoot: {
        backgroundColor: '#B8E582',
      },
      errorRoot: {
        backgroundColor: '#ED7375',
      },
      messageText: {
        color: 'black !important',
      },
    },

    ColorPalettes: {
      switchBaseSpacing: {
        padding: '9px 12px 12px 9px',
      },
      colorPaletteColors: {
        border: 'none',
        '&[aria-label="weiss"]': {
          border: '1px solid black',
        },
      },
      selectedColorWrap: {
        boxShadow: 'none',
        border: '2px solid black !important',
      },
    },
    FullScreenView: {
      thumbnailGrid: {
        left: '50% !important',
      },
      buttonView: {
        left: 'auto',
      },
    },
    ImageColorize: {
      buttonContainer: {
        '& .MuiFormControl-root': {
          display: 'none',
          width: 0,
        },
        '& .MuiButton-root': {
          maxWidth: '100%',
          [theme.breakpoints.down('xs')]: {
            marginLeft: 0,
          },
        },
      },
    },
    PdfDownload: {
      activeButton: {
        borderRadius: '2 !important',
        backgroundColor: 'black',
        border: 'none',
        '& span': {
          color: 'white',
          textTransform: 'uppercase',
        },
        '&:hover': {
          border: '1px solid black',
          backgroundColor: 'white',
          boxShadow: 'none',
          '& span': {
            color: 'black',
          },
        },
      },
    },
    SendEmail: {
      activeButton: {
        borderRadius: '2 !important',
        backgroundColor: 'black',
        border: 'none',
        '& span': {
          color: 'white',
          textTransform: 'uppercase',
        },
        '&:hover': {
          border: '1px solid black',
          backgroundColor: 'white',
          boxShadow: 'none',
          '& span': {
            color: 'black',
          },
        },
      },
    },
    LoadConfiguration: {
      activeButton: {
        borderRadius: '2 !important',
        backgroundColor: 'black',
        border: 'none',
        '& span': {
          color: 'white',
          textTransform: 'uppercase',
        },
        '&:hover': {
          border: '1px solid black',
          backgroundColor: 'white',
          boxShadow: 'none',
          '& span': {
            color: 'black',
          },
        },
      },
    },
    SaveConfiguration: {
      saveConfigurationCode: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '24px !important',
        width: '100%',
        fontSize: 15,
      },
      successResult: {
        padding: 8,
        width: '50%',
        height: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      },
      activeButton: {
        borderRadius: '2 !important',
        backgroundColor: 'black',
        border: 'none',
        '& span': {
          color: 'white',
          textTransform: 'uppercase',
        },
        '&:hover': {
          border: '1px solid black',
          backgroundColor: 'white',
          boxShadow: 'none',
          '& span': {
            color: 'black',
          },
        },
      },
    },
    MuiDialogTitle: {
      root: {
        '& h2': {
          fontSize: '1.25rem !important',
        },
      },
    },
    ToolbarList: {
      ToolbarIconButton: {
        '& span': {
          fontSize: 36,
        },
      },
    },
    DesignerAlignTarget: {
      root: {
        [theme.breakpoints.down('xs')]: {
          marginTop: 0,
        },
      },
    },
  });
};

// eslint-disable-next-line react/prop-types,react/display-name
export default ({ children }) => (
  <ConnectedThemeProvider customTheme={customTheme} withTheme={overrideTheme}>
    {children}
  </ConnectedThemeProvider>
);
